module.exports = __webpack_public_path__ + "media/images/user_perfil-368d83441e80bdf28d119e687a7fbd17.svg";